import Swal from 'sweetalert2/dist/sweetalert2'

// @planningcenter/sweetalert2 preset options
import {
  standardAlertOptions,
  successAlertOptions,
  errorAlertOptions,
  standardConfirmOptions,
  createConfirmOptions,
  destroyConfirmOptions,
} from '@planningcenter/sweetalert2'

export const alert = Swal.mixin(standardAlertOptions)
export const alertSuccess = Swal.mixin(successAlertOptions)
export const alertError = Swal.mixin(errorAlertOptions)
export const confirm = Swal.mixin(standardConfirmOptions)
export const confirmDestroy = Swal.mixin(destroyConfirmOptions)
export const confirmCreate = Swal.mixin(createConfirmOptions)
